module.exports = __webpack_public_path__ + "static/media/tabMenu2023-10-25.910dbb73.png";